wp.blocks.unregisterBlockVariation( 'core/group', 'full-width-group' );
wp.blocks.unregisterBlockVariation( 'core/button', 'button-with-icon' );

wp.blocks.registerBlockVariation( 'core/button', {
    name: 'button-big',
    title: 'Big',
    attributes: {
        className: 'is-variation-splitkon-button-big',
    }
} );

wp.blocks.registerBlockVariation( 'core/button', {
    name: 'button-small',
    title: 'Small',
    attributes: {
        className: 'is-variation-splitkon-button-small',
    }
});

wp.blocks.registerBlockVariation( 'core/button', {
    name: 'button-external',
    title: 'External',
    attributes: {
        className: 'is-variation-splitkon-button-external',
    }
} );

wp.blocks.registerBlockVariation( 'core/button', {
    name: 'button-scroll-down',
    title: 'Scroll down',
    attributes: {
        className: 'is-variation-splitkon-button-scroll-down',
    }
} );

wp.blocks.registerBlockVariation( 'core/details', {
    name: 'faq-item',
    title: 'FAQ item',
    attributes: {
        className: 'is-style-splitkon-faq-item',
    }
});

wp.blocks.registerBlockVariation( 'core/details', {
    name: 'info-expanded-dimensions',
    title: 'Information expanded (dimensions)',
    attributes: {
        summary: 'Se mer detaljer om dimensjoner',
        className: 'splitkon-information-expanded splitkon-information-expanded--dimensions'
    },
    innerBlocks: [
        [ 'core/paragraph', { className: 'splitkon-information-expanded__text', content: 'Standard oppbygning av Splitkon massivtre. Paneler kan leveres med lameller i tverrgående og langsgående retning i yttersjikt.' } ],
        [ 'core/image', { className: 'splitkon-information-expanded__image', 'url': `${splitkon.assetsUrl}/images/placeholder.png`, sizeSlug: 'medium-large' } ],
        [ 'core/group', { className: 'splitkon-information-expanded__table-titles', layout: { type: 'flex', orientation: 'horizontal', flexWrap: 'nowrap' } }, [
            [ 'core/paragraph', { content: 'Elementtykkelse, mm', 'style': { 'typography': { 'fontWeight': '700' } } } ],
            [ 'core/paragraph', { content: 'Antall lamellsjikt pr element- varierer', 'style': { 'typography': { 'fontWeight': '700' } } } ]]
        ],
        [ 'core/table', { 'body': [
            { 'cells': [
                { 'content': '60', 'tag': 'td' },
                { 'content': '3S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '80', 'tag': 'td' },
                { 'content': '3S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '100', 'tag': 'td' },
                { 'content': '3S', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '120', 'tag': 'td' },
                { 'content': '3S', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '140', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '160', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '180', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '200', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '220', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '5S', 'tag': 'td' },
                { 'content': '7S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '240', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '7S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '260', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '7S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '280', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '7S', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
            ] },
            { 'cells': [
                { 'content': '300', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '', 'tag': 'td' },
                { 'content': '7S', 'tag': 'td' },
                { 'content': '9S', 'tag': 'td' },
            ] },
        ] } ]
    ],
});

wp.blocks.registerBlockVariation( 'core/details', {
    name: 'info-expanded-surfaces',
    title: 'Information expanded (surfaces)',
    attributes: {
        summary: 'Se overflater vi leverer',
        className: 'splitkon-information-expanded splitkon-information-expanded--surfaces'
    },
    innerBlocks: [
        [ 'core/paragraph', { className: 'splitkon-information-expanded__text', content: 'Massivtre fra Splitkon er tilgjengelig i tre forskjellige kvaliteter, avhengig av bruksformål. Splitkon leverer massivtre uten kantliming for å få jevn fordeling av spalter ved uttørking og ikke større tørkesprekker.' } ],
        [ 'core/group', { className: 'splitkon-information-expanded__surfaces', layout: { 'type': 'flex', orientation: 'horizontal', flexWrap: 'nowrap' }, metadata: { name: 'Surfaces' } }, [
            [ 'core/group', { className: 'splitkon-information-expanded__surface', layout: { type: 'constrained' }, metadata: { name: 'Surface' } }, [
                [ 'core/image', { width: '93px', height: '85px', scale: 'cover', sizeSlug: 'thumbnail', 'url': `${splitkon.assetsUrl}/images/placeholder-surfaces.svg` } ],
                [ 'core/heading', { level: 4, content: 'Synlig kvalitet (s)' } ],
                [ 'core/paragraph', { content: 'Egnet for permanent synlige flater i boliger og offentlige bygninger. Pusset med 80 korning og overflatekontrollert i henhold til utseendeklasse «Synlig».' } ]
            ]],
            [ 'core/group', { className: 'splitkon-information-expanded__surface', layout: { type: 'flex',orientation: 'vertical' }, metadata: { name: 'Surface' } }, [
                [ 'core/image', { width: '93px', height: '85px', scale: 'cover', sizeSlug: 'thumbnail', 'url': `${splitkon.assetsUrl}/images/placeholder-surfaces.svg` } ],
                [ 'core/heading', { level: 4, content: 'Ikke-synlig kvalitet (u)' } ],
                [ 'core/paragraph', { content: 'Brukes i bygninger uten spesielle krav til overflatekvalitet. Høvlet overflate i henhold til utseendeklasse «Ikke synlig». Kan inneholde overflatefeil og limrester.' } ]
            ]],
            [ 'core/group', { className: 'splitkon-information-expanded__surface', layout: { type: 'flex',orientation: 'vertical' }, metadata: { name: 'Surface' } }, [
                [ 'core/image', { width: '93px', height: '85px', scale: 'cover', sizeSlug: 'thumbnail', 'url': `${splitkon.assetsUrl}/images/placeholder-surfaces.svg` } ],
                [ 'core/heading', { level: 4, content: 'Industriell kvalitet (i)' } ],
                [ 'core/paragraph', { content: 'For bruk i bygninger med lavere krav (ref. synlig kvalitet) til overflatekvalitet. Høvlet og overflatekontrollert og forbered i henhold til utseendeklasse «Industriell». Kan inneholde overflatefeil og limrester.' } ]
            ]],
        ]],
    ],
});

wp.blocks.registerBlockVariation( 'core/group', {
    name: 'benefits-item',
    title: 'Benefit item',
    attributes: {
        className: 'splitkon-benefits-item',
        layout: {
            type: 'flex',
            flexWrap: 'nowrap'
        },
        metadata: {
            name: 'Benefit'
        }
    },
    innerBlocks: [
        ['core/image', {
            className: 'splitkon-benefits-item__icon',
            url: `${ splitkon.assetsUrl }/images/icon-black-thermometer.svg`,
            sizeSlug: 'thumbnail'
        }],
        ['core/details', {className: 'splitkon-benefits-item__details', summary: 'Inneklima'}, [
            ['core/paragraph', {content: 'Tre er et av de mest miljøvennlige byggematerialene vi har, men det er langt fra den eneste fordelen ved å bygge med Splitkon-massivtre og limtre.'}],
            ['core/buttons', {}, [
                ['core/button', {className: 'splitkon-benefits-item__button', text: 'Se brannsikkerhet'}]
            ]]
        ]],
    ]
} );

wp.blocks.registerBlockVariation( 'core/group', {
    name: 'benefits-item-no-image',
    title: 'Benefit item (without image)',
    attributes: {
        className: 'splitkon-benefits-item',
        layout: {
            type: 'flex',
            flexWrap: 'nowrap'
        },
        metadata: {
            name: 'Benefit'
        }
    },
    innerBlocks: [
        ['core/details', {className: 'splitkon-benefits-item__details', summary: 'Inneklima'}, [
            ['core/paragraph', {content: 'Tre er et av de mest miljøvennlige byggematerialene vi har, men det er langt fra den eneste fordelen ved å bygge med Splitkon-massivtre og limtre.'}],
            ['core/buttons', {}, [
                ['core/button', {className: 'splitkon-benefits-item__button', text: 'Se brannsikkerhet'}]
            ]]
        ]],
    ]
} );

wp.blocks.registerBlockVariation( 'core/group', {
    name: 'assortment-item',
    title: 'Assortment item',
    attributes: {
        className: 'splitkon-assortment-item',
        layout: {
            type: 'flex',
            orientation: 'vertical'
        },
        metadata: {
            name: 'Assortment item'
        }
    },
    innerBlocks: [
        ['core/image', { url: `${ splitkon.assetsUrl }/images/placeholder.png`, sizeSlug: 'medium-large' }],
        ['core/details', {className: 'splitkon-assortment-item__details', showContent: true, summary: 'Standard limtre'}, [
            ['core/paragraph', {content: 'Limtre har stor formbarhet og høy bæreevne. Bjelkene leveres i fasthetsklasse GL 30 C, produsert i henhold til gjeldende europeiske standarder.'}],
            ['core/group', {className: 'splitkon-assortment-item__dimensions',layout: {type: 'flex', orientation: 'vertical'}, metadata: {name: 'Dimensions'}}, [
                ['core/paragraph', {content: '<strong>Høyde</strong> 90mm - 630mm'}],
                ['core/paragraph', {content: '<strong>Bredder pr 25 mm</strong> 90mm - 215mm'}],
            ]],
        ]],
    ]
} );

wp.blocks.registerBlockVariation( 'core/group', {
    name: 'elements-item',
    title: 'Elements item',
    attributes: {
        className: 'splitkon-elements-item',
        layout: {
            type: 'flex',
            orientation: 'vertical'
        },
        metadata: {
            name: 'Elements item'
        }
    },
    innerBlocks: [
        ['core/image', {className: 'splitkon-elements-item__image', url: `${ splitkon.assetsUrl }/images/placeholder.png`, sizeSlug: 'medium' }],
        ['core/group', {className: 'splitkon-elements-item__content',layout: {type: 'flex', orientation: 'horizontal'}}, [
            ['core/image', {className: 'splitkon-elements-item__icon', url: `${ splitkon.assetsUrl }/images/icon-black-covers.svg`, width: '24px', height: '24px', scale:'contain', sizeSlug: 'thumbnail'}],
            ['core/paragraph', {content: 'Dekker'}],
            ['core/details', {className: 'splitkon-elements-item__details', summary: 'POPUP'}, [
                ['core/group', {className: 'splitkon-elements-item__popup'}, [
                    ['core/button', {className: 'splitkon-elements-item__close-popup-button', text: `<img style="width: 11px;" src="${ splitkon.assetsUrl }/images/icon-blue-close.svg" alt="">`}],
                    ['core/media-text', {className: 'wp-block-media-text--rounded-corners', mediaWidth: 35.5,imageFill: true,layout: {type: 'flex', orientation: 'vertical'}, metadata: {name: 'Dimensions'}}, [
                        ['core/heading', { level: 3, content: `<img style="width: 30px;" src="${ splitkon.assetsUrl }/images/icon-black-bricks.svg" alt="">Dekker` }],
                        ['core/paragraph', {content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'}],
                        ['core/group', {className: 'splitkon-elements__popup-details'}, [
                            ['core/paragraph', {content: '<strong>Bredder pr 25 mm</strong> 90mm - 215mm'}],
                            ['core/paragraph', {content: '<strong>Høyde</strong> 90mm - 630mm'}],
                        ]],
                    ]],
                ]],
            ]],
        ]],
    ]
} );

wp.blocks.registerBlockVariation( 'core/group', {
    name: 'show-more-info-box',
    title: 'Show more info box',
    attributes: {
        className: 'splitkon-show-more-info-box is-style-splitkon-beige',
        layout: {
            type: 'flex',
            orientation: 'vertical'
        },
        metadata: {
            name: 'Show more info box'
        }
    },
    innerBlocks: [
        ['core/heading', { level: 4, content: `Bærekraft tall` }],
        ['core/group', {className: 'splitkon-show-more-info-box__content',layout: {type: 'flex', orientation: 'horizontal'}}, [
            ['core/paragraph', {content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla hendrerit lorem non tristique venenatis. Etiam consectetur gravida gravida. Integer varius non ligula eget dictum. Duis at feugiat velit. Sed quis porta sem. Ut pellentesque urna nec justo suscipit, eget sollicitudin lorem hendrerit. Sed faucibus eu velit eu sagittis. Cras ut tempus ante, nec tempor eros. Nunc euismod sapien sit amet lorem dignissim, eget ornare metus suscipit'}],
        ]],
        ['core/button', {className: 'splitkon-show-more-info-box__button is-style-splitkon-link-button', text: 'Vis mer'}]
    ]
} );

wp.blocks.registerBlockVariation( 'core/group', {
    name: 'contact-person',
    title: 'Contact person',
    attributes: {
        className: 'splitkon-contact-person',
        layout: {
            type: 'flex',
            orientation: 'vertical'
        },
        metadata: {
            name: 'Contact person'
        }
    },
    innerBlocks: [
        ['core/image', {'url': `${splitkon.assetsUrl}/images/placeholder.png`, sizeSlug: 'medium-large' }],
        ['core/heading', { level: 5, content: 'Contact person name', 'textColor':'brand-dark' }],
        ['core/paragraph', { className: 'splitkon-contact-person__role', content: `Contact person role` }],
        ['core/paragraph', { className: 'splitkon-contact-person__email', content: `<a href="mailto:epost@epost.no" target="_blank" rel="noreferrer noopener"><img style="width: 20px;height: 21px;" src="${splitkon.assetsUrl}/images/icon-black-message.svg" alt="">epost@epost.no</a>` }],
        ['core/paragraph', { className: 'splitkon-contact-person__tel', content: `<a href="tel:12345698" target="_blank" rel="noreferrer noopener"><img style="width: 24px;height: 24px;" src="${splitkon.assetsUrl}/images/icon-black-phone.svg" alt="">123 45 698</a>` }],
    ]
} );
